import React, { useState, useEffect, useRef, useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ThemeContext from '../../utils/theming';

import TransitionContainer from '../../components/Transition/TranstionContainer';

import Overlay from '../Widget/Overlay';
import OverlayPublisher from '../Widget/OverlayPublisher';
import OverlayPartner from '../Widget/OverlayPartner';
import WidgetHeader from '../Widget/WidgetHeader';

import { Footer, Description, Content, Body } from '../DefaultStyles/Shared';
import { Container } from '../DefaultStyles/Details';
import ShareDrawer from '../../components/ShareDrawer';
import VidContainer from '../../components/RecordVideo/VideoContainer';

import isMobile from '../../utils/detectMobileAccurate';
import { isPortrait } from '../../utils/size';
import { copyFor } from '../../copy/copy';

import LocalRepAction from '../../components/LocalRep/LocalRepAction';
import { AutoScalingButtonSet } from '../../components/Buttons/AutoScalingButtonSet';

import {
    onBackWithinCard,
    setOverlayPartnerVisible,
    setExitingCardProps,
    getExitingCardProps
} from '../Widget/actions';

import { isLongText } from '../../components/Shared/commonFunctions';
import { ActionTypes, CardTypes } from '../../utils/enums';

import { continueToConfirmationCard } from '../RecordVideo/actions';

const isMobileRecorder = isMobile()
const accountHash = '466ece2c21e241d2273abd6322eb5927'; //addPipe
let vidContainer;

const RecordVideoInstructions = props => {
    const [vidStyles, setVidStyles] = useState({ visible: false });
    const [isSubmitting,setIsSubmitting] = useState(false);
    const [isRerecord,setIsRerecord] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        if (isMobileRecorder) setUpVidRecorder();

        return () => {
            vidContainer &&
                vidContainer.srcObject.getTracks().forEach(track => track.stop());
        };
    }, []);

    function setUpVidRecorder() {
        const AB = containerRef.current;

        const pipeParams = {
            size: { width: AB.offsetWidth, height: AB.offsetHeight },
            qualityurl: `avq/${props.recordingQuality}.xml`,
            accountHash,
            eid: 'H5oWwm',
            mrt: props.maxRecordTime,
            cornerradius: 0,
            bgCol: '0xffffff',
            asv: 0, //auto save
            sis: 1 //skip initial screen
        };

        function saveVideoCallback(recorderObject, videoName, videoId) {
            props.continueToConfirmationCard(
                props.apiRequestData,
                videoName,
                videoId,
                props.isEmailAction,
                props.savedFirstVideo,
                props.actionIdentifier
            );
            if (!isMobileRecorder) setTimeout(recorderObject.remove, 4000);
        }

        window.PipeSDK.insert('vidContainer', pipeParams, function(recorderObject) {

            setVidStyles({ visible: true });

            recorderObject.onSaveOk = function(
                recorderId,
                streamName,
                streamDuration,
                cameraName,
                micName,
                audioCodec,
                videoCodec,
                fileType,
                videoId,
                audioOnly,
                location
            ) {
                setIsSubmitting(true);
                saveVideoCallback(recorderObject, streamName, videoId);
            };

            recorderObject.onVideoUploadSuccess = function(
                recorderId,
                streamName,
                filetype,
                videoId,
                audioOnly,
                location
            ) {
                document.querySelector('#label-pipe-file-input-vidContainer').remove();
                setIsSubmitting(true);
                saveVideoCallback(recorderObject, streamName, videoId);
            };

            recorderObject.btStopRecordingPressed = function(){
                setIsRerecord(true)
            };
        });
    }

    return (
    <TransitionContainer
        zIndex={2}
        isSubmitting={props.isSubmitting || isSubmitting}
        isBackTransition={props.isBackTransition}
    >
        <Container ref={containerRef}>
            <VidContainer id="vidContainer" vidStyles={vidStyles} isRerecord={isRerecord} theme={useContext(ThemeContext)} />
            <Overlay />
            <OverlayPublisher />
            <OverlayPartner transitionType="right-to-left" />
            <Body>
                <WidgetHeader />
                <Content isVideoCard={true} isSingleAction={true}>
                    <Description
                        className="ie-single-action-details-description"
                        style={{lineHeight:1.5}}
                        scaleFactor={
                            isPortrait() && props.isVisualLink
                                ? 0.8
                                : 1
                        }
                        dangerouslySetInnerHTML={{
                            __html: props.recordingInstructions
                        }}
                        isShortText={isLongText(
                            props.recordingInstructions,
                            250
                        )}
                        isLongText={isLongText(
                            props.recordingInstructions,
                            300
                        )}
                        isExtraLongText={isLongText(
                            props.recordingInstructions,
                            400
                        )}
                        onClick={e =>
                            props.setOverlayPartnerVisible(
                                true,
                                e,
                                false
                            )
                        }
                    />
                    {!isMobileRecorder &&
                    (<AutoScalingButtonSet>
                        <LocalRepAction
                            isLongText={
                                !isPortrait() &&
                                isLongText(props.recordingInstructions, 40)
                            }
                            action={{ label: props.buttonLabel }}
                            onClick={() => {
                                props.setExitingCardProps('recordvideo', props, props.activeAction);
                                setUpVidRecorder();
                            }}
                        />
                    </AutoScalingButtonSet>)}
                </Content>
                <Footer>
                    <ShareDrawer
                        beforeBack={() => {
                            props.setExitingCardProps('recordvideo', props, props.activeAction);
                        }}
                        goBack={() => {
                            return props.card.type === CardTypes.actionChoice
                                ? props.onBackWithinCard(
                                      props.actionIdentifier,
                                      props.card,
                                      true,
                                      true
                                  )
                                : null;
                        }}
                        fullwidth={props.card.type === CardTypes.actionChoice}
                        rightAlign={props.card.type !== CardTypes.actionChoice}
                        hasBackButton={props.card.type === CardTypes.actionChoice}
                        backgroundColor={'#fff'}
                    />
                </Footer>
            </Body>
        </Container>
    </TransitionContainer>
    );
};

RecordVideoInstructions.propTypes = {
    actionIdentifier: PropTypes.string.isRequired,
    activeAction: PropTypes.object.isRequired,
    buttonLabel: PropTypes.string.isRequired,
    card: PropTypes.object.isRequired,
    cardTitle: PropTypes.string.isRequired,
    onBackWithinCard: PropTypes.func.isRequired,
    setExitingCardProps: PropTypes.func.isRequired,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    recordingInstructions: PropTypes.string.isRequired,
    maxRecordTime: PropTypes.number.isRequired,
    recordingQuality: PropTypes.string.isRequired,
    isEmailAction: PropTypes.bool,
    isBackTransition: PropTypes.bool,
    isSubmitting: PropTypes.bool,
    savedFirstVideo: PropTypes.bool
};

export default connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            'recordvideo',
            ['/recordvideo'],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        const isRepContactAction = state.widget.activeAction.representativeSearch;
        const maxRecordTime = state.widget.activeAction.maximumVideoLengthInSeconds;

        return {
            actionIdentifier: state.widget.activeAction.identifier,
            activeAction: state.widget.activeAction,
            apiRequestData: state.widget.apiRequestData,
            buttonLabel: copyFor('buttons', 'recordNow', 'recordvideo'),
            card: state.widget.cards[state.widget.activeAction.order - 1],
            cardTitle: state.widget.cards[
                state.widget.activeAction.order - 1
            ].heading.replace(/@articleUrl/g, state.widget.articleUrl),
            recordingInstructions:
                (state.widget.activeAction.recordingInstructions ||
                 copyFor('instructions' + (isRepContactAction ? 'Reps' : ''), 'text', 'recordvideo'))
                    .replace(/@seconds/g, maxRecordTime),
            maxRecordTime,
            recordingQuality: state.widget.activeAction.defaultRecordingQuality.toLowerCase(),
            isEmailAction: state.widget.activeAction.representativeSearch,
            isBackTransition: state.recordVideo.isBackTransition,
            isSubmitting: state.recordVideo.isSubmitting,
            savedFirstVideo: state.recordVideo.savedFirstVideo
        };
    },
    {
        onBackWithinCard,
        setExitingCardProps,
        setOverlayPartnerVisible,
        continueToConfirmationCard
    },
    null,
    {
        areStatesEqual: (next, prev) => {
            if (next.widget.activeAction.type !== ActionTypes.RecordVideo) return true;
            return next === prev;
        }
    }
)(RecordVideoInstructions);
